import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { ChangedData } from '../changed-data/ChangedData';
import { createSimpleUser } from '../user/SimpleUser';

/**
 * # HistoryData
 *
 * HistoryData을 설명하세요.
 */
export const HistoryData = types
  .model('HistoryData')
  // --------------------------------------------------------------------------
  .props({
    changeRound: types.optional(types.number, 0),
    changedData: types.optional(types.array(ChangedData), []),
    regDt: types.optional(types.number, 0),
    updDt: types.optional(types.number, 0),
    regUser: createSimpleUser(),
    updUser: createSimpleUser(),

    // regDt: types.optional(types.number, 0),
    // updDt: types.optional(types.number, 0),
    // projectHistSid: types.optional(types.number, 0),
    // projectSid: types.optional(types.number, 0),
    // projectHistCd: createModelCode(),
    // changeHistory: types.optional(types.string, ''),
    // quotationFilePath: types.maybeNull(types.string),
    // regUser: createSimpleUser(),
    // updUser: createSimpleUser(),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model historyData --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IHistoryData;
      (Object.keys(newProps) as THistoryDataKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type THistoryData = Instance<typeof HistoryData>;
type THistoryDataSnapshot = SnapshotOut<typeof HistoryData>;

export interface IHistoryData extends THistoryData {}
export type THistoryDataKeys = keyof THistoryDataSnapshot & string;
export interface IHistoryDataSnapshot extends THistoryDataSnapshot {}
export const createHistoryData = () => types.optional(HistoryData, {} as THistoryData);
